export enum UserRoles {
  SUPER_ADMIN = "Super Administrador",
  SOPORTE = "Soporte",
}
